import './style.scss';
import { __ } from '@wordpress/i18n';
import { applyFilters } from '@wordpress/hooks';

const ImageSelector = ({ options, value, onChange }) => {
    const hasValidSubscription = Array.isArray(bwdcv_data?.user?.subscriptionOrders)
        ? bwdcv_data.user.subscriptionOrders.some((order) => {
              const isActive = order.status === 'completed' || order.status === 'processing';
              const perDownload = parseInt(order.per_download, 10);
              const billingPeriod = parseInt(order.billing_period, 10);
              return isActive && (perDownload >= 2 || billingPeriod >= 1);
          })
        : false;
        
    const templateVisibility = applyFilters(
        'bwdcv-template-visibility', false
    );

    const isLicenseActive = bwdcv_data?.licenseStatus === 'activate';
    const filteredOptions = options.filter((option) => {
        const styleNumber = parseInt(option.value.replace('style', ''), 10);

        // Active/Inactive check — admin থেকে deactivate করা template hide করো
        const isStyleActive = bwdcv_data?.checkboxes?.[styleNumber] === "1";
        if (!isStyleActive) {
            return false;
        }

        if (!isLicenseActive) {
            return styleNumber <= 2;
        }
        if (isLicenseActive && templateVisibility === true) {
            return true;
        }
        if (isLicenseActive) {
            return true;
        }
        return false;
    });

    return (
        <div className="template-selector">
            {filteredOptions.map((option) => {
                const styleNumber = option.value.replace('style', '');
                const optionKey = `cv_allow_style${styleNumber}`;
                const isProTemplate = bwdcv_data?.options?.[optionKey] === "1";                
                const badge = !hasValidSubscription ? (
                    <span className={isProTemplate ? 'bwd-cv-pro' : 'bwd-cv-free'}>
                        {__(isProTemplate ? 'PRO' : 'FREE', 'cv-builder')}
                    </span>
                ) : null;

                return (
                    <button
                        key={option.value}
                        className={`template-item ${value === option.value ? 'selected' : ''}`}
                        onClick={() => onChange(option.value)}
                    >
                        <img src={option.imageUrl} alt={option.label} title={option.label} />
                        <div className="image-label">{option.label}</div>
                        <div className="checkmark">✓</div>
                        {badge}
                        {option.isAts && (
                            <span className="bwdcv-ats">{__('ATS', 'cv-builder')}</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
};

export default ImageSelector;